import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { usePortalTarget } from '../../components/UIProvider/3b439fae09430a89bf9bbc95661684ba0b31a690249158604440a1f4e9233a91.cfe-internal.js';

var Portal = function Portal(_ref) {
  var children = _ref.children,
      portalTarget = _ref.portalTarget;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      container = _useState2[0],
      setContainer = _useState2[1];

  var globalPortalTarget = usePortalTarget();
  useEffect(function () {
    var element = document.createElement('div');
    var target = portalTarget || globalPortalTarget || document.body;
    target.appendChild(element);
    setContainer(element);
    return function () {
      target.removeChild(element);
    };
  }, [portalTarget, globalPortalTarget]); // only render children once parent has been appended to DOM

  return container ? /*#__PURE__*/ReactDOM.createPortal(children, container) : null;
};

var Portal$1 = Portal;

export { Portal$1 as default };
